import {Button, Fab, useMediaQuery} from '@material-ui/core';
import * as AgentNewsAdministrationRouteConstants from 'AgentNewsAdministration/AgentNewsAdministrationRouteConstants';
import React from 'react';
import AddIcon from '@material-ui/icons/Add';
import {Link, useHistory} from 'react-router-dom';

const AgentNewsAdministrationMenu = () => {
  const isDesktopView = useMediaQuery((theme: any) => theme.breakpoints.up('lg'));

  return isDesktopView ? <AgentNewsDesktopActions /> : <AgentNewsMobileActions />;
};

const AgentNewsDesktopActions = () => (
  <Link to={AgentNewsAdministrationRouteConstants.NewsAdministrationEntry()}>
    <Button color="primary" variant="contained">
      Add News Entry
    </Button>
  </Link>
);

const AgentNewsMobileActions = () => {
  const history = useHistory();

  return (
    <Fab
      className="agent-news-administration__mobile-add-button"
      color="primary"
      onClick={() => history.push(AgentNewsAdministrationRouteConstants.NewsAdministrationEntry())}
    >
      <AddIcon />
    </Fab>
  );
};

export default AgentNewsAdministrationMenu;
